import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type PanZoomState = {
  translateX: number;
  translateY: number;
  scale: number;
  isPanningMode: boolean;
};

const initialState: PanZoomState = {
  translateX: 0,
  translateY: 0,
  scale: 1,
  isPanningMode: false,
};

const panZoomSlice = createSlice({
  name: 'panZoom',
  initialState,
  reducers: {
    setPanZoom(state, action: PayloadAction<Omit<PanZoomState, 'isPanningMode'>>) {
      state.translateX = action.payload.translateX;
      state.translateY = action.payload.translateY;
      state.scale = action.payload.scale;
    },
    setTranslate(state, action: PayloadAction<{ x: number; y: number }>) {
      state.translateX = action.payload.x;
      state.translateY = action.payload.y;
    },
    setTranslateX(state, action: PayloadAction<number>) {
      state.translateX = action.payload;
    },
    setTranslateY(state, action: PayloadAction<number>) {
      state.translateY = action.payload;
    },
    setScale(state, action: PayloadAction<number>) {
      state.scale = action.payload;
    },
    setIsPanningMode(state, action: PayloadAction<boolean>) {
      state.isPanningMode = action.payload;
    },
  },
});

export const {
  setPanZoom,
  setTranslate,
  setTranslateX,
  setTranslateY,
  setScale,
  setIsPanningMode,
} = panZoomSlice.actions;
export default panZoomSlice.reducer;
